export default "__VITE_ASSET__af8807e1__"